<template>
  <div class="base-info">
    <formTemplate :title="key === 'create' ? '新建物流模板' : '修改物流模板'" :formData="logistics_info">
      <template v-slot:body>

        <!-- <el-form-item label="模板号" prop="template_id">
          <el-input style="width: 60%;" v-model="logistics_info.template_id" placeholder="请输入模板号" />
        </el-form-item> -->
        <el-form-item label="模板名称" prop="template_name">
          <el-input style="width: 60%;" v-model="logistics_info.template_name" placeholder="请输入模板名称" />
        </el-form-item>
        <el-form-item label="运费模式">
          <el-select style="width: 60%;" v-model="logistics_info.shipping_mode" placeholder="请选择运费模式" clearable>
            <el-option v-for="item in shippingModeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="可发货区域">
          <addressCascader ref="inAddressCascaderRef" @input="addressCascaderInput($event, 'is')"></addressCascader>
        </el-form-item>
        <el-form-item label="可包邮区域">
          <addressCascader ref="unAddressCascaderRef" @input="addressCascaderInput($event, 'un')"></addressCascader>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-switch v-model="logistics_info.state" active-text="启用" inactive-text="禁用" />
        </el-form-item>
        <el-form-item label="允许组合" prop="allow_combine">
          <el-switch v-model="logistics_info.allow_combine" active-text="允许" inactive-text="禁止" />
        </el-form-item>

        <el-form-item label="规则">
          <el-table :data="rule" size="small" border stripe style="width:100%">
            <el-table-column prop="rule_no" label="编号" min-width="80">
              <template slot-scope="scope">
                <el-input v-model="scope.row.rule_no" size="mini" placeholder="编号(数字越小等级越高)" />
              </template>
            </el-table-column>

            <el-table-column prop="is_default" label="默认规则" width="150">
              <template slot-scope="scope">
                <el-checkbox
                  :disabled="have_default === true && (scope.row.is_default === false || scope.row.is_default === 'false')"
                  v-model="scope.row.is_default" true-label="true" false-label="false">默认</el-checkbox>
              </template>
            </el-table-column>

            <el-table-column prop="mini_qty" label="最小数量" min-width="100" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.mini_qty" :min="0" size="mini" style="width:100%" />
              </template>
            </el-table-column>

            <el-table-column prop="max_qty" label="最大数量" min-width="100" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.max_qty" :min="0" size="mini" style="width:100%" />
              </template>
            </el-table-column>

            <el-table-column prop="amount" label="金额" min-width="100" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.amount" :min="0" :precision="2" size="mini" style="width:100%" />
              </template>
            </el-table-column>

            <el-table-column prop="has_free" label="是否可包邮" width="150">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.has_free">包邮</el-checkbox>
              </template>
            </el-table-column>

            <el-table-column prop="free_condition" label="包邮条件" min-width="120">
              <template slot-scope="scope">
                <!-- <el-input v-model="scope.row.free_condition" size="mini" placeholder="条件" /> -->
                <el-select :disabled="!scope.row.has_free == true || !scope.row.has_free == 'true'"
                  v-model="scope.row.free_condition" size="mini" style="margin-left:10px;width:120px;" placeholder="条件">
                  <el-option v-for="option in free_condition_options" :key="option.value" :label="option.label"
                    :value="option.value"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column prop="free_value" label="包邮值" min-width="100">
              <template slot-scope="scope">
                <el-input :disabled="!scope.row.has_free == true || !scope.row.has_free == 'true'"
                  v-model="scope.row.free_value" size="mini" placeholder="值" />
              </template>
            </el-table-column>

            <el-table-column label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <!--  <el-button type="text" size="mini" @click="updateRule">修改</el-button> -->
                <el-button type="text" size="mini" @click="removeRule(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" size="small" plain @click="addRuleRow" style="margin-top:10px">
            <i class="el-icon-plus"></i> 新增规则
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" size="small" @click="saveChange" style="margin-top:10px">
            保存该模板
          </el-button>
        </el-form-item>
      </template>
    </formTemplate>
    <div class="empty-block"></div>
  </div>

</template>
<script>

import { onlinesCreateShippingTemplate, onlinesUpdateRule, onlinesShippingtemplateQuery, onlinesShippingtemplateUpdate } from "@/api/onlines/goods.js";
import formTemplate from '../goods/components/formTemplate.vue';
import addressCascader from '../../components/AddressCascader.vue';
export default {
  components: {
    formTemplate, addressCascader
  },
  computed: {
    have_default() {
      for (let i = 0; i < this.rule.length; i++) {
        console.log("this.logistics_info.rule[i]", this.rule[i].is_default);
        //eslint-disable-next-line
        if (this.rule[i].is_default == true || this.rule[i].is_default == 'true') {
          return true;
        }
      }
      return false
    }
  },
  data() {
    return {
      /* limit_props: {
        multiple: true,
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          setTimeout(() => {
            const nodes = Array.from({ length: level + 1 })
              .map(item => ({
                value: ++id,
                label: `选项${id}`,
                leaf: level >= 2
              }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 1000);
        }
      }, */
      key: "",
      shippingModeOptions: [
        { value: 1, label: '自提' },
        { value: 2, label: '自配送' },
        { value: 3, label: '同城配送' },
        { value: 4, label: '快递配送' },
        { value: 5, label: '物流配送' }
      ],
      free_condition_options: [
        { label: '按件', value: '0' },
        { label: '按金额', value: '1' },
        { label: '两者都可', value: '2' }
      ], //按件-0/按金额-1/两者都可-2
      logistics_info: {
        template_id: "",
        template_name: "",
        shipping_mode: "",
        state: true,
        allow_combine: true,
        limit_area: [],
        free_limte_area: []
      },
      rule: [
        {
          rule_no: "",
          is_default: true,
          mini_qty: 0,
          max_qty: 0,
          amount: 0,
          has_free: true,
          free_condition: "",
          free_value: ""
        }
      ]
    }
  },
  created() {
    this.key = this.$route.params.key;
    if (this.key === 'update') {
      if (this.$route.params.value) {
        const v = JSON.parse(this.$route.params.value);
        console.log("v----------------------- ------------------------zf", v);
        this.logistics_info = {
          template_id: v.template_id,
          template_name: v.template_name,
          shipping_mode: v.shipping_mode ?? 1,
          /*eslint-disable*/
          state: v.state === "True" ? true : false,
          allow_combine: v.state === "True" ? true : false,
          limit_area: JSON.parse(v.limit_area) || [],
          free_limte_area: v.free_limte_area || []
        }
        this.$nextTick(() => {
          this.$refs.inAddressCascaderRef.setValueByCodes(v.limit_area);
          this.$refs.inAddressCascaderRef.setValueByCodes(v.free_limte_area);
        })

        ////setValueByCodes
        this.getTemplate(v.template_id);
      }
      /* this.getTemplate(this.$route.params.value) */
    }
  },
  methods: {
    /**
     * 获取物流模板详情
     */
    async getTemplate(tid) {
      const res = await onlinesShippingtemplateQuery(tid);
      console.log("获取物流模板", res);
      if (res.length) {
        this.rule = res.map(item => {
          return {
            ...item,
            has_free: item.has_free === "True" ? true : false,
            is_default: item.has_free === "True" ? true : false
          }
        });
      }
    },
    addressCascaderInput(v, k) {
      console.log("v----------------------- zf", v);
      console.log("v----------------------- zf", this.logistics_info);
      try {
        if (k === 'is') {
          this.logistics_info.limit_area.push(...v.codes.map(item => {
            return item[item.length - 1]
          }));
        } else if (k === 'un') {
          this.logistics_info.free_limte_area.push(...v.codes.map(item => {
            return item[item.length - 1]
          }));
        }
      } catch (e) {
        console.log("eeeeeeeeeeeeeeeeeeeeeee", e);
      }

    },
    /**
     * 修改规则
     * @param
     */
    async updateRule(template_id) {
      const res = await onlinesUpdateRule({
        template_id,
        rule: this.rule.map(item=>{
          return {
            ...item,
            amount:item.amount*100
          }
        })
      });
      console.log("修改规则", res);
      if (res.state) {
        this.successMessage(res.message);
      }
    },
    async updateTemplate() {
      const res = await onlinesShippingtemplateUpdate(this.logistics_info);
      console.log("res===========", res);
      if (res.state) {
        this.successMessage(res.message);
      }
    },
    ConsoleLog() {

    },
    /* haveDefault() , */
    addRuleRow() {
      this.rule.push({
        rule_no: "",
        is_default: false,
        mini_qty: 0,
        max_qty: 0,
        amount: 0,
        has_free: false,
        free_condition: "",
        free_value: ""
      });
    },
    /**
     * 点击保存按钮
     */
    async saveChange() {
      if (this.key === 'create') {
        const id = await this.createNewShipp();
        console.log("物流模板id", id);
        this.updateTemplate(id);
        this.updateRule(this.logistics_info.template_id);
      } else {
        this.updateTemplate();
        this.updateRule(this.logistics_info.template_id);
      }
    },
    /**
     * 创建运费模板
     */
    async createNewShipp() {
      const res = await onlinesCreateShippingTemplate(this.logistics_info);
      console.log("res--------------------", res);
      if (res.state === true) {
        this.successMessage(res.message);
        return res.template_id
      }
    },
    updateRules() {

    },
    /**
     * 修改运费模板
     */
    updateShipp() {

    },
    removeRule() {

    }
  }
};
</script>
<style lang="less" scoped>
.el-input {
  width: 100%;
}
</style>